define('core/utils/lang/isElement',[],function () {
    'use strict';

    // NOTE: Ported from underscore 1.8.3
    return function isElement(obj) {
        return Boolean(obj && obj.nodeType === 1);
    };
});

